import { render, staticRenderFns } from "./wt-input-number.vue?vue&type=template&id=4c45de33"
import script from "./wt-input-number.vue?vue&type=script&lang=js"
export * from "./wt-input-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports